export default {
  dashboard: {
    icon: require("@/assets/i/white/icon-dashboard.svg"),
    iconHover: require("@/assets/i/gray/icon-dashboard.svg"),
    titleEs: "Dashboard",
    titleEn: "Dashboard",
    to: "/dashboard"
  },
  inbound: {
    icon: require("@/assets/i/white/icon-recepcion-w.svg"),
    iconHover: require("@/assets/i/gray/icon-recepcion.svg"),
    titleEs: "Entradas",
    titleEn: "Entries",
    children: [
      {
        titleEs: "Lista ordenes",
        titleEn: "List orders",
        to: "/inbound/",
        icon: require("@/assets/i/workflow.png"),
        iconHover: require("@/assets/i/workflowLime.png")
      },
      {
        titleEs: "Contenedores",
        titleEn: "Containers",
        to: "/inbound/containers",
        icon: require("@/assets/i/workflow.png"),
        iconHover: require("@/assets/i/workflowLime.png")
      },
      {
        titleEs: "Agregar orden de compra",
        titleEn: "Add purchase order",
        to: "/inbound/order/add",
        roles: [1, 2, 3]
      }
    ]
  },
  outbound: {
    icon: require("@/assets/i/white/icon-online.svg"),
    iconHover: require("@/assets/i/gray/icon-online.svg"),
    titleEs: "Expediciones",
    titleEn: "Expeditions",
    children: [
      {
        titleEs: "Dashboard",
        titleEn: "Dashboard",
        to: "/online/",
        icon: require("@/assets/i/workflow.png"),
        iconHover: require("@/assets/i/workflowLime.png")
      },
      {
        titleEs: "Agregar orden de online",
        titleEn: "Add online order",
        to: "/online/order/add",
        roles: [1, 2, 3]
      }
    ]
  },
  movements: {
    icon: require("@/assets/i/white/icon-entradas-salidas-w.svg"),
    iconHover: require("@/assets/i/gray/icon-entradas-salidas.svg"),
    titleEs: "Movimientos",
    titleEn: "Movements",
    children: [
      {
        titleEs: "Salida",
        titleEn: "Departure",
        to: "/movements/"
      },
      {
        titleEs: "Entrada",
        titleEn: "Entry",
        to: "/movements/entry/"
      },
      {
        titleEs: "Agregar orden de movimiento",
        titleEn: "Add movement order",
        to: "/movements/order/add",
        roles: [1, 2, 3]
      }
    ]
  },
  inventory: {
    icon: require("@/assets/i/white/icon-inventario.svg"),
    iconHover: require("@/assets/i/gray/icon-inventario.svg"),
    titleEs: "Inventario",
    titleEn: "Inventory",
    children: [
      {
        titleEs: "Recuento",
        titleEn: "Count",
        to: "/inventory/",
        icon: require("@/assets/i/white/icon-inventario.svg"),
        iconHover: require("@/assets/i/gray/icon-inventario.svg")
      },
      // {
      //   titleEs: "Stock",
      //   titleEn: "Stock",
      //   to: "/inventory/stocks/",
      //   icon: require("@/assets/i/workflow.png"),
      //   iconHover: require("@/assets/i/workflowLime.png")
      // },
      {
        titleEs: 'Stock global',
        titleEn: 'Global stock',
        to: '/inventory/global-stock/',
        icon: require('@/assets/i/workflow.png'),
        iconHover: require('@/assets/i/workflowLime.png')

      },
      {
        titleEs: 'Stock de items ',
        titleEn: 'Item stock',
        to: '/inventory/global-item-stock/',
        icon: require('@/assets/i/workflow.png'),
        iconHover: require('@/assets/i/workflowLime.png')

      }
      // {
      //   titleEs: 'Palés',
      //   titleEn: 'Palés',
      //   to: '/inventory/boxstocks/',
      //   icon: require('@/assets/i/workflow.png'),
      //   iconHover: require('@/assets/i/workflowLime.png')

      // }
    ]
  },
  pos: {
    icon: require("@/assets/i/white/icon-tpvpos-w.svg"),
    iconHover: require("@/assets/i/gray/icon-tpvpos.svg"),
    titleEs: "Punto de venta",
    titleEn: "Point of sale",
    children: [
      {
        titleEs: "Devoluciones",
        titleEn: "Returns",
        to: "/pos",
        icon: require("@/assets/i/workflow.png"),
        iconHover: require("@/assets/i/workflowLime.png")
      },
      {
        titleEs: "Ventas",
        titleEn: "Sales",
        to: "/pos/exits",
        icon: require("@/assets/i/workflow.png"),
        iconHover: require("@/assets/i/workflowLime.png")
      }
    ]
  },
  trace_epc: {
    icon: require("@/assets/i/white/epc-track-w.svg"),
    iconHover: require("@/assets/i/gray/epc-track.svg"),
    titleEs: "Trazabalidad EPC",
    titleEn: "EPC trazability",
    children: [
      {
        titleEs: "Trazabalidad EPC",
        titleEn: "EPC trazability",
        to: "/track-epc",
        icon: require("@/assets/i/workflow.png"),
        iconHover: require("@/assets/i/workflowLime.png")
      },
    ]
  },
  // support: {
  //   icon: require("@/assets/i/white/support-w.svg"),
  //   iconHover: require("@/assets/i/gray/support.svg"),
  //   titleEs: "Support",
  //   titleEn: "Support",
  //   to: "/support"
  // }
  //
  // workflow: {
  //   icon: require('@/assets/i/white/icon-flujo.svg'),
  //   iconHover: require('@/assets/i/gray/icon-flujo.svg'),
  //   titleEs: 'Flujo',
  //   titleEn: 'Flow',
  //   children: [{
  //     titleEs: 'Entradas',
  //     titleEn: 'Tickets',
  //     to: '/empty', // to: '/workflow/inbound',
  //     icon: require('@/assets/i/workflow.png'),
  //     iconHover: require('@/assets/i/workflowLime.png')
  //   },
  //   {
  //     titleEs: 'Salidas',
  //     titleEn: 'Departures',
  //     to: '/empty', // to: '/workflow/outbound',
  //     icon: require('@/assets/i/workflow.png'),
  //     iconHover: require('@/assets/i/workflowLime.png')
  //   }
  //   ]
  // }
};
